module.exports = "<youtube-player [videoId]=\"id\" (ready)=\"onReady($event)\"></youtube-player>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/youtube-video-dialog/youtube-video-dialog.component.html
// module id = ../../../../../src/app/components/youtube-video-dialog/youtube-video-dialog.component.html
// module chunks = main